import { useEffect } from "react";

export function usePageTitle(title, description) {
  useEffect(() => {
    document.title = `${title} | Brian Boland Psychotherapy & Counselling`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
  }, [title, description]);
}
